export default {"src":"/_next/static/media/arrow-rotate.cffafa07.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};